import type { MaxCartLimitable } from '@iheartjane/types';

import type { Cart } from '@jane/bloom/types/schemas/bloom/checkout';
import type { ProductMaxCartQuantityOptions } from '@jane/bloom/viewModels/productDetail';

interface GetMaxCartQuantityArgs {
  cart: Cart;
  currentProduct: MaxCartLimitable & { product_id: number };
  currentWeight: string | undefined;
  storeId?: number;
}

/**
 * @returns the remaining quantity of a product you are allowed to add to the given cart
 */
export const getMaxCartQuantity = ({
  cart,
  currentProduct,
  currentWeight,
  storeId,
}: GetMaxCartQuantityArgs): number => {
  let filter = 'max_cart_quantity';
  let priceId = 'each';

  if (currentWeight) {
    priceId = currentWeight.replace(' ', '_');
    filter = `max_cart_quantity_${priceId}`;
  }

  const maxProductQty = currentProduct[filter as ProductMaxCartQuantityOptions];

  const existingCartProduct =
    cart.storeId === storeId &&
    cart.items.find(
      (item) =>
        item.productId === currentProduct.product_id && item.priceId === priceId
    );
  return existingCartProduct
    ? maxProductQty - existingCartProduct.count
    : maxProductQty;
};
